// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../styles/typography.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * == BSD2 LICENSE ==
 * Copyright (c) 2016, Tidepool Project
 *
 * This program is free software; you can redistribute it and/or modify it under
 * the terms of the associated License, which is identical to the BSD 2-Clause
 * License as published by the Open Source Initiative at opensource.org.
 *
 * This program is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the License for more details.
 *
 * You should have received a copy of the License along with this program; if
 * not, you can obtain one from Tidepool Project at tidepool.org.
 * == BSD2 LICENSE ==
 */

.Tooltip--tooltip--nJbNU {
  display: block;
  background-color: #FFFFFF;
  border: solid;
  pointer-events: none;
  position: absolute;
  border-radius: 4px;
  z-index: 1000;
}

.Tooltip--content--hPQZv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 12px;
  box-sizing: border-box;
}

.Tooltip--content--hPQZv span {
  width: 100%;
}

.Tooltip--title--rpDIV {
  background-color: var(--tooltip-title-bg);
}

.Tooltip--tail--mFMOe {
  width: 0px;
  height: 0px;
  border-style: solid;
  border-color: transparent;
  position: absolute;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/tooltips/Tooltip.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;EAeE;;AAEF;EACE,cAAc;EAEd,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EAGE,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["/*\n * == BSD2 LICENSE ==\n * Copyright (c) 2016, Tidepool Project\n *\n * This program is free software; you can redistribute it and/or modify it under\n * the terms of the associated License, which is identical to the BSD 2-Clause\n * License as published by the Open Source Initiative at opensource.org.\n *\n * This program is distributed in the hope that it will be useful, but WITHOUT\n * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS\n * FOR A PARTICULAR PURPOSE. See the License for more details.\n *\n * You should have received a copy of the License along with this program; if\n * not, you can obtain one from Tidepool Project at tidepool.org.\n * == BSD2 LICENSE ==\n */\n\n.tooltip {\n  display: block;\n  composes: defaultSize from '../../../styles/typography.css';\n  background-color: #FFFFFF;\n  border: solid;\n  pointer-events: none;\n  position: absolute;\n  border-radius: 4px;\n  z-index: 1000;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 10px 12px;\n  box-sizing: border-box;\n}\n\n.content span {\n  width: 100%;\n}\n\n.title {\n  composes: mediumContrastText from '../../../styles/typography.css';\n  composes: content;\n  background-color: var(--tooltip-title-bg);\n}\n\n.tail {\n  width: 0px;\n  height: 0px;\n  border-style: solid;\n  border-color: transparent;\n  position: absolute;\n}\n\n:export {\n  tooltipTitleBg: var(--tooltip-title-bg);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipTitleBg": `var(--tooltip-title-bg)`,
	"tooltip": `Tooltip--tooltip--nJbNU ${___CSS_LOADER_ICSS_IMPORT_0___.locals["defaultSize"]}`,
	"content": `Tooltip--content--hPQZv`,
	"title": `Tooltip--title--rpDIV ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mediumContrastText"]} Tooltip--content--hPQZv`,
	"tail": `Tooltip--tail--mFMOe`
};
export default ___CSS_LOADER_EXPORT___;
